<template>
  <div class="lineBox">
    <div>
      <el-radio-group
        v-model="currentFilter.modeValue"
        size="medium"
        @change="changeModel"
      >
        <el-radio-button label="客户数" />
        <el-radio-button label="新客数" />
        <el-radio-button label="销售额" />
      </el-radio-group>
    </div>
    <div class="view-flex line2 view-search">
      <el-select
        v-model="currentFilter.dateRange"
        placeholder="请选择"
        size="medium"
        class="search-input1"
        @change="changeDateRange"
      >
        <el-option
          v-for="item in filterDateNameOption"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
      <template v-if="currentFilter.dateRange === -1">
        <div class="split1">
          自定义
        </div>
        <el-date-picker
          v-model="dateRangerValue"
          type="daterange"
          align="right"
          unlink-panels
          size="medium"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="dateRangerOptions"
          class="search-range"
          @change="handleChangeDateTime"
        />
      </template>
      <div class="split2">
        员工
      </div>
      <el-select
        v-model="currentFilter.salesperson_id"
        placeholder="请选择"
        size="medium"
        class="search-input2"
        @change="changeSalesperson"
      >
        <el-option
          v-for="item in filterEmployeesOption"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
      <el-button
        size="medium"
        @click="startRender"
      >
        重置
      </el-button>
    </div>
    <div
      id="line-home-container"
      class="line2"
    />
  </div>
</template>

<script>
import { Line } from '@antv/g2plot'
import { getTodayDate } from '@/utils/date'
export default {
  data () {
    const timeOptions = [
      {
        value: 2,
        label: '近一周'
      },
      {
        value: 3,
        label: '近一月'
      },
      {
        value: -1,
        label: '自定义日期'
      }
    ]

    const dateRangerOptions = {
      shortcuts: [
        {
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        },
        {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        },
        {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }
      ]
    }

    return {
      filterDateNameValue: 'week',
      filterDateNameOption: timeOptions,
      dateRangerOptions,
      dateRangerValue: '',
      filterEmployeesOption: [],
      currentFilter: {
        page: 1,
        pageSize: 99,
        //三种类型 total new sale
        mode: 'total',
        modeValue: '客户数',
        //三种类型 day month year
        dateRange: 2,
        begin: '',
        end: '',
        salesperson_id: '',
        salesperson_name: ''
      },
      lineData: [],
      line: null
    }
  },
  mounted () {
    this.getSalesManList()
    this.startRender()
  },
  methods: {
    startRender () {
      this.currentFilter = {
        ...this.currentFilter,
        page: 1,
        pageSize: 99,
        //三种类型 total new sale
        mode: 'total',
        modeValue: '客户数',
        //三种类型 day month year
        dateRange: 2,
        begin: '',
        end: '',
        salesperson_id: '',
        salesperson_name: ''
      }
      this.dateRangerValue = ''
      this.getMemberStatic()
    },
    getSalesManList () {
      const self = this
      this.$api['staffManagement/salesman']
        .getSalesmanList({ page: 1, pageSize: 999 })
        .then((response) => {
          const { list } = response
          self.filterEmployeesOption = list.map((item) => ({
            value: item.salesperson_id,
            label: item.salesperson_name
          }))
        })
    },
    handleChangeDateTime ([startTime, endTime]) {
      console.log('handleChangeDateTime')
      console.log(startTime)
      console.log(endTime)
      const begin = getTodayDate(startTime)
      const end = getTodayDate(endTime)
      this.currentFilter = {
        ...this.currentFilter,
        begin,
        end
      }
      this.fetchWhich()
    },
    changeSalesperson (value) {
      this.currentFilter = {
        ...this.currentFilter,
        salesperson_id: value
      }
      this.fetchWhich()
    },

    changeModel (value) {
      function tran (value) {
        let mode
        switch (value) {
          case '新客数':
            mode = 'new'
            break
          case '销售额':
            mode = 'sale'
            break
          case '客户数':
            mode = 'total'
            break
          default:
            mode = 'total'
            break
        }
        return mode
      }
      this.currentFilter = {
        ...this.currentFilter,
        modeValue: value,
        mode: tran(value)
      }
      this.fetchWhich()
    },
    fetchWhich () {
      const { mode } = this.currentFilter
      if (mode != 'sale') {
        this.getMemberStatic()
      } else {
        this.getSaleStatic()
      }
    },
    getSaleStatic () {
      const { dateRange, mode, begin, end, salesperson_id, pageSize, page } = this.currentFilter
      const self = this
      let params = {
        page,
        page_size: pageSize,
        salesperson_id
      }
      if (this.currentFilter.dateRange === -1) {
        params.start_date = begin
        params.end_date = end
      } else {
        params.dateRange = dateRange
      }
      this.$api['home/index'].getSaleStatics(params).then((response) => {
        const { list } = response
        self.lineData = list.map((item) => ({
          Date: item.statistic_date,
          Value: Number(item.pay_fee) / 100
        }))
        self.drawLine()
      })
    },
    changeDateRange (value) {
      this.currentFilter = {
        ...this.currentFilter,
        dateRange: value
      }
      if (value !== -1) {
        this.fetchWhich()
        this.dateRangerValue = ''
      }
    },
    getMemberStatic () {
      const { dateRange, mode, begin, end, salesperson_id, pageSize, page } = this.currentFilter
      const self = this
      let params = {
        page,
        page_size: pageSize,
        salesperson_id
      }
      if (this.currentFilter.dateRange === -1) {
        params.start_date = begin
        params.end_date = end
      } else {
        params.dateRange = dateRange
      }
      this.$api['home/index'].getMemberStatics(params).then((response) => {
        const { list } = response
        if (mode === 'total') {
          self.lineData = list.map((item) => ({ Date: item.day, Value: item.total }))
          self.drawLine()
        } else {
          self.lineData = list.map((item) => ({ Date: item.day, Value: item.new }))
          self.drawLine()
        }
      })
    },
    drawLine () {
      const { lineData } = this
      console.log('lineData', lineData)
      if (this.line) {
        this.line.update({
          data: lineData,
          padding: 'auto',
          xField: 'Date',
          yField: 'Value'
        })
      } else {
        this.line = new Line('line-home-container', {
          data: lineData,
          padding: 'auto',
          xField: 'Date',
          yField: 'scales'
        })
        this.line.render()
        this.line.update({
          data: lineData,
          padding: 'auto',
          xField: 'Date',
          yField: 'Value'
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.lineBox {
  .line2 {
    margin-top: 22px;
    .split1 {
      margin: 0 15px;
      line-height: 33px;
    }
    .split2 {
      margin: 0 15px;
      line-height: 33px;
    }
  }
  .view-search {
    ::v-deep {
      .el-date-editor .el-range-separator {
        width: 20px;
      }
      .search-input1 {
        .el-input__inner {
          width: 120px;
        }
      }
      .search-input2 {
        .el-input__inner {
          width: 140px;
        }
      }
      .search-range.el-input__inner {
        width: 280px;
      }
    }
  }
}
</style>
